import { createApp } from 'vue'
import i18n from './i18n/index.js';
import App from './App.vue'
import router from './router'
import './assets/reset.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import Swiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';
import ECharts from 'vue-echarts';
import { use } from 'echarts/core';
import { BarChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';





// import en from './locales/en.json';
// import zh from './locales/zh.json';

const app = createApp(App);
// Vue.use(VueI18n);
// app.use(VueSlickCarousel);
use([CanvasRenderer, BarChart]);
app.component('v-chart', ECharts);
app.use(Swiper)
app.use(i18n);
app.use(ElementPlus);
app.use(router);
app.mount('#app')
